<template lang="pug">
section.b-feed(v-if="data.length")
    header.header-5.mb-4 Новости юррынка
    a._item.-news(
        v-for="(entry, idx) in data",
        :key="`feed-item-${idx}`",
        :href="entry.url"
    )
        ._heading
            ._datetime.mb-1.me-2 {{ parseTimestamp(entry.timestamp) }}
            div
                header._header.mb-1 {{ entry.title }}
</template>

<script>
export default {
    name: "FeedComponent",
    props: {
        data: { required: true, type: Array, default: () => [] },
    },
    methods: {
        parseTimestamp(timestamp) {
            return new Date(timestamp * 1000)
                .toLocaleDateString("ru", {
                    hour: "numeric",
                    minute: "numeric",
                })
                .split(", ")[1];
        },
    },
};
</script>
